module.exports = __webpack_public_path__ + "static/media/26UNRWA18.68b31fa0.jpg";